import { Directive, ElementRef, forwardRef, HostListener, Inject, Input, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EventBus, EventBusBase } from '@skylab-angular-shared/core';
import { ValueAccessor } from './value-accessor';

@Directive({
    selector: 'ins-select',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectValueAccessorDirective),
            multi: true,
        },
    ]
})
export class SelectValueAccessorDirective<TIn> extends ValueAccessor {
    @Input() public cleanAfterSelect = false;
    @Input() public emptyItem: unknown = null;
    @Input() public items!: TIn[];
    @Input() public converter = {
        convert: (value: any) => value,
        convertBack: (value: any) => value
    };

    public constructor(
        elm: ElementRef,
        @Inject(EventBus) eventBus: EventBusBase
    ) {
        super(elm, eventBus);
    }

    public override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

        if (changes['items'] && !changes['items'].firstChange) {
            this.elm.nativeElement.value = this.converter.convert(this.converter.convertBack(this.currentValue));
        }
    }

    public override writeValue(value: TIn): void {
        this.elm.nativeElement.value = this.currentValue = Array.isArray(value)
            ? value.map(elem => this.converter.convert(elem))
            : this.converter.convert(value) || this.emptyItem;
    }

    public override registerOnChange(fn: (value: TIn | TIn[]) => void): void {
        super.registerOnChange(value => {
            const newValue = Array.isArray(value)
                ? value.map(elem => this.converter.convertBack(elem))
                : this.converter.convertBack(value);
            fn(newValue);
        });
    }

    @HostListener('insSelect', ['$event.target'])
    protected handleInputEvent(elm: unknown): void {
        this.handleChangeEvent(elm as HTMLOptionElement, (elm as HTMLOptionElement).value);
        if (this.cleanAfterSelect) {
            this.elm.nativeElement.value = null;
        }
    }
}
